import { Fragment } from "react";
import { useLocation } from "react-router-dom";
import SEO from "../../components/seo";
import LayoutOne from "../../layouts/LayoutOne";
import Breadcrumb from "../../wrappers/breadcrumb/Breadcrumb";

const routeTitles = {
  "/tiendas_tc": "Tiendas",
};

const getBreadcrumbTitle = (pathname) =>
  routeTitles[pathname] ||
  pathname
    ?.replace("/", "")
    ?.replaceAll("-", " ")
    ?.replace(/\b\w/g, (char) => char.toUpperCase());

const PageContentBlank = ({ children }) => {
  const { pathname } = useLocation();
  const breadcrumbTitle = getBreadcrumbTitle(pathname);

  return (
    <Fragment>
      <SEO titleTemplate="Contact" description="Proceso de forma de Pago" />
      <LayoutOne headerTop="visible">
        <Breadcrumb
          pages={[
            { label: "Inicio", path: process.env.PUBLIC_URL + "/" },
            { label: breadcrumbTitle, path: process.env.PUBLIC_URL + pathname },
          ]}
        />
        <div className="contact-area pt-100 pb-100">
          <div className="container">{children}</div>
        </div>
      </LayoutOne>
    </Fragment>
  );
};

export default PageContentBlank;
